import { connect } from 'react-redux'
import { openLoans, markLoansChecked } from 'src/actions/homeowner'
import { selectCurrentCELs as selectDictionary } from 'src/store/selectors/home/dictionary'
import {
  selectCurrentCELs,
  selectUnverifiedCELs,
  selectPrincipalDiff
} from 'src/store/selectors/home/loans'
import { selectShouldCheckLoanNumbers } from 'src/store/selectors/home/homeowner'

const selectInterestAndPrincipalData = connect(
  state => {
    const dictionary = selectDictionary(state)
    const principal = dictionary.principalPaidTotal()
    const interest = dictionary.interestPaidTotal()
    const total = principal + interest
    const principalDiff = selectPrincipalDiff(state)

    const unverifiedLoans = selectUnverifiedCELs(state)
    const shouldCheckNumbers = selectShouldCheckLoanNumbers(state)

    return {
      shouldCheckNumbers,
      unverifiedLoans,
      loans: selectCurrentCELs(state),
      principal: Math.round(principal),
      interest: Math.round(interest),
      principalDiff,
      principalRatio: principal / total,
      interestRatio: interest / total,
      emptyState: total === 0
    }
  },
  dispatch => ({
    openLoans: () => {
      dispatch(openLoans())
      dispatch(markLoansChecked())
    },
    confirmLoanEstimates: unverifiedLoans => {
      dispatch(markLoansChecked(unverifiedLoans))
    }
  })
)

export default selectInterestAndPrincipalData
